/**
 * "View as" tabs: the token lives in this tab's sessionStorage only, so other tabs stay signed in as the HR admin.
 * Every API call from this tab carries it (see api.ts).
 */
const KEY = 'attDash.viewAs';

export const viewAs = {
  get(): string | null {
    try {
      return sessionStorage.getItem(KEY);
    } catch {
      return null;
    }
  },
  set(token: string): void {
    try {
      sessionStorage.setItem(KEY, token);
    } catch {
      /* private mode: the tab will show it has ended */
    }
  },
  clear(): void {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      /* nothing to clear */
    }
  },
};

/**
 * A tab opened at /impersonate#<token>: keep the token in this tab and open the report, before the app starts, so the
 * very first request already runs as that person. /impersonate#ended (or no token) shows the ended page.
 */
export function captureViewAs(): void {
  const t = location.hash.slice(1);
  if (location.pathname !== '/impersonate' || !t || t === 'ended') return;
  viewAs.set(t);
  history.replaceState(null, '', '/');
}
